
    import Vue from "vue";

    const END_POINT = "/requirement";

    const getRequirement = id => Vue.axios.get(END_POINT + "/" + id);

    const getRequirements = ids => Vue.axios.get(END_POINT + "/by-ids", {params: {ids}});

    const getAllRequirements = data => Vue.axios.get(END_POINT, {params: data});

    const createRequirement = requirement => Vue.axios.post(END_POINT,  requirement );

    const createAllRequirements = Requirements => Vue.axios.post(END_POINT + "/all",  Requirements );

    const updateRequirement = requirement => Vue.axios.put(END_POINT  + "/" + requirement.id,  requirement );

    const deleteRequirement = id => Vue.axios.delete(END_POINT  + "/" + id);

    const getStudentRequirements = (ids, liteResponse) => Vue.axios.get(END_POINT  + "/student", {params: {studentIds: ids, liteResponse}});

    const getStaffRequirements = ids => Vue.axios.get(END_POINT  + "/staff", {params: {staffIds: ids}});

    /**
     * 
     * @param {startDate,  endDate,  centerId} data 
     * @returns 
     */
    const getRequirementsDue = data => Vue.axios.get(END_POINT  + "/due", {params: data});


    export {
      getRequirement,
      getRequirements,
      getAllRequirements,
      createRequirement,
      createAllRequirements,
      updateRequirement,
      deleteRequirement,
      getStudentRequirements,
      getStaffRequirements,
      getRequirementsDue
    };
    